import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

const Container = ({ className, children }) => (
  <div
    className={cn(
      "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 overflow-y-visible",
      className
    )}
  >
    <div className="max-w-5xl mx-auto">{children}</div>
  </div>
);

Container.defaultProps = { className: "", children: null };
Container.propTypes = { className: PropTypes.string, children: PropTypes.node };

export default Container;
